import { ThemeTypes } from "app/core/theme/theme-types";
import { WHITELABEL_LIST } from "@core";
import { NCONNECTVOICE_WHITELABEL_DATA } from "app/core/white-label/data/nconnect-voice-whitelabel.data";
import { O2_SIP_TRUNK_WHITELABEL_DATA } from "app/core/white-label/data/o2-sip-trunk-whitelabel.data";

export const WHITELABEL_DATA_LIST: WHITELABEL_LIST = {
  [ThemeTypes.NconnectVoiceTheme]: NCONNECTVOICE_WHITELABEL_DATA,
  [ThemeTypes.O2SIPTrunkTheme]: O2_SIP_TRUNK_WHITELABEL_DATA,
};
